<h2 mat-dialog-title>Add Company</h2>
@if (!isLoading) {
    <form [formGroup]="addCompanyForm" novalidate>
        <mat-dialog-content class="mat-typography">
            <div class="form-grid">

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Company ID</mat-label>
                    <input matInput name="id" formControlName="company_id" required autocomplete="id">
                    <mat-error>ID is required.</mat-error>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Company Name</mat-label>
                    <input matInput name="name" formControlName="company_name" required autocomplete="name">
                    <mat-error>Name is required.</mat-error>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Country</mat-label>
                    <input matInput name="country" formControlName="country_head_quarters" required autocomplete="country-name">
                    <mat-error>Country is required.</mat-error>
                </mat-form-field>

                <mat-form-field class="full" appearance="fill">
                    <mat-label>Descripcion</mat-label>
                    <textarea matInput name="description" formControlName="description" required autocomplete="description"></textarea>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Contact</mat-label>
                    <input matInput name="contact" formControlName="contact" required autocomplete="contact">
                </mat-form-field>

            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-flat-button color="primary" [disabled]="addCompanyForm.invalid" (click)="onAddCompany()">Save</button>
        </mat-dialog-actions>
    </form>
}@else{
    <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner class="custom-spinner" mode="indeterminate"></mat-progress-spinner>
    </div>
}
